import { injectCpmsBoNetworkApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-network.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoNetworkApi = injectCpmsBoNetworkApi(baseApi);

export const {
  useCpmsBoCreateNetworkMutation,
  useCpmsBoGetNetworkQuery,
  useCpmsBoGetNetworksPaginatedQuery,
  useCpmsBoUpdateNetworkMutation,
} = cpmsBoNetworkApi;
